<template>
  <span>
    <template v-if="priceReduced === null || priceReduced === 0">
      {{ price | formatCurrency
      }}<span class="unit" v-if="type === 'club'"> / Monat</span>
    </template>
    <template v-else>
      <span class="reducedPrice">{{ price | formatCurrency }}</span>
      {{ priceReduced | formatCurrency
      }}<span class="unit" v-if="type === 'club'"> / Monat</span>
    </template>
  </span>
</template>

<script>
export default {
  name: "CoursePrice",
  props: ["price", "priceReduced", "type"]
};
</script>
